// TDHP maddi/maddi olmayan duran varlık üst hesapları — yeni kayıtlar bunların altında gruplanır
export const NATURES = [
  "250 - ARAZİ VE ARSALAR",
  "251 - YERALTI VE YERÜSTÜ DÜZENLERİ",
  "252 - BİNALAR",
  "253 - TESİS, MAKİNE VE CİHAZLAR",
  "254 - TAŞITLAR",
  "255 - DEMİRBAŞLAR",
  "256 - DİĞER MADDİ DURAN VARLIKLAR",
  "260 - HAKLAR",
  "261 - ŞEREFİYE",
  "262 - KURULUŞ VE ÖRGÜTLENME GİDERLERİ",
  "263 - ARAŞTIRMA VE GELİŞTİRME GİDERLERİ",
  "264 - ÖZEL MALİYETLER",
  "267 - DİĞER MADDİ OLMAYAN DURAN VARLIKLAR",
];

export const emptyDeed = {
  address: "", province: "", district: "", neighborhood: "", block_no: "", parcel_no: "", nature: "",
  building_block: "", floor: "", door_no: "", owner: "", market_value: "", appraisal_value: "", mortgage_bank: "", mortgage_degree: "",
  dask_start: "", dask_end: "", konut_start: "", konut_end: "",
};

// poliçe bitişi = başlangıç + 1 yıl (29 Şubat → 28 Şubat)
export const plusOneYear = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  const dt = new Date(Date.UTC(y + 1, m - 1, d));
  if (dt.getUTCMonth() !== m - 1) dt.setUTCDate(0);
  return dt.toISOString().slice(0, 10);
};

// tapu bilgileri yalnız arazi/arsa ve bina mahiyetinde açılır; araç bilgileri yalnız taşıtlarda
export const DEED_NATURES = ["250 - ARAZİ VE ARSALAR", "252 - BİNALAR"];
export const isDeedNature = (nature) => DEED_NATURES.includes(nature);
export const VEHICLE_NATURE = "254 - TAŞITLAR";
export const isVehicleNature = (nature) => nature === VEHICLE_NATURE;
export const emptyVehicle = { plate: "", market_value: "", chassis_no: "", trafik_start: "", trafik_end: "", kasko_start: "", kasko_end: "" };

// poliçe bitiş rozeti: bitti gri, 30 gün içinde kırmızı, aksi yeşil
export const insuranceCls = (d) => {
  if (!d) return "";
  const t = new Date(); const in30 = new Date(t.getFullYear(), t.getMonth(), t.getDate() + 30).toISOString().slice(0, 10);
  return d < t.toISOString().slice(0, 10) ? "bg-slate-200 text-slate-600" : d <= in30 ? "bg-red-100 text-red-800" : "bg-emerald-100 text-emerald-800";
};

export const emptyAsset = {
  name: "", nature: "", kind: "", serial_no: "", asset_account_code: "",
  depreciation_account_code: "", depreciation_code: "", depreciation_rate: "", cost_value: "",
  purchase_date: "", useful_life_years: "", warranty_years: "", warranty_end: "",
  project_id: "", project_name: "", assignee_personnel_id: "", assignee_name: "", assigned_at: "",
  deed: null, vehicle: null,
};

export const cls = "w-full px-2.5 py-1.5 text-xs border border-slate-300 rounded-md bg-white focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none";
export const todayStr = () => new Date().toISOString().slice(0, 10);
export const emptyDispose = () => ({ type: "Hurda", date: todayStr(), amount: "", buyer: "", note: "" });

// kalan yıl ve son amortisman yılı alış tarihi + faydalı ömürden otomatik hesaplanır
export function depreciationYears(form) {
  const life = parseInt(form.useful_life_years, 10);
  const buyYear = form.purchase_date ? Number(form.purchase_date.slice(0, 4)) : null;
  const lastYear = life > 0 && buyYear ? buyYear + life : null;
  const remaining = lastYear ? Math.max(0, lastYear - new Date().getFullYear()) : null;
  return { life, lastYear, remaining };
}

export function L({ label, children }) {
  return (
    <label className="block">
      <span className="block text-[11px] font-semibold text-slate-600 mb-1 uppercase tracking-wide">{label}</span>
      {children}
    </label>
  );
}
